import { CURSOR_ENUM } from './../components/Cursor/Cursor';
import { createContext } from 'react';

const CursorContext = createContext({
  cursor: CURSOR_ENUM.DEFAULT,
  setCursor: (cursor: CURSOR_ENUM) => {},
});

export default CursorContext;
